import { Aurelia } from "aurelia-framework";
import { PLATFORM } from "aurelia-pal";
import { UserManager } from "oidc-client-ts";

import { BootstrapFormRenderer } from "./components/bootstrap-form-renderer";
import { OidcConfiguration } from "./infrastructure/configure-oidc-client";
import { appLogger, ConfigureAppLogging } from "./infrastructure/logging";

export async function configure(aurelia: Aurelia) {
  aurelia.use
    .standardConfiguration()
    .plugin(PLATFORM.moduleName("aurelia-validation"));

  aurelia.container.registerHandler("bootstrap-form", x =>
    x.get(BootstrapFormRenderer)
  );
  let oidcConfig: OidcConfiguration = aurelia.container.get(OidcConfiguration);
  let userManager = oidcConfig.createUserManager();
  aurelia.container.registerInstance(UserManager, userManager);

  ConfigureAppLogging();

  await aurelia.start();
  await aurelia.setRoot(PLATFORM.moduleName("app"));

  appLogger.info("Identity is ready.");
}
